import { DetectionSource } from "../Common/DetectionSource";

export class TruckLoadDTO {
    loadingId: number;
    diggingPatternId: number;
    destinationId: number;
    truckId: number;
    loads: number;
    hour: number;
    tonnes?: number;
    materialTypeClassId: number;
    addedBy?: string;
    updatedBy?: string;
    rowVersion?: string;
    detectionSource?: DetectionSource;
    isVerified?: boolean;
    truckRef?: string;
    destinationName?: string;
    canEdit?: boolean;

    constructor(data: {
        loadingId: number;
        diggingPatternId: number;
        destinationId: number;
        truckId: number;
        loads: number;
        hour: number;
        tonnes?: number;
        materialTypeClassId: number;
        addedBy?: string;
        updatedBy?: string;
        rowVersion?: string;
        detectionSource?: DetectionSource;
        isVerified?: boolean;
        truckRef?: string;
        destinationName?: string;
        canEdit?: boolean;
    }) {
        this.loadingId = data.loadingId;
        this.diggingPatternId = data.diggingPatternId;
        this.destinationId = data.destinationId;
        this.truckId = data.truckId;
        this.loads = data.loads;
        this.hour = data.hour;
        this.tonnes = data.tonnes;
        this.materialTypeClassId = data.materialTypeClassId;
        this.addedBy = data.addedBy;
        this.updatedBy = data.updatedBy;
        this.rowVersion = data.rowVersion;
        this.detectionSource = data.detectionSource;
        this.isVerified = data.isVerified;
        this.truckRef = data.truckRef;
        this.destinationName = data.destinationName;
        this.canEdit = data.canEdit;
    }
}
